























import {Component, Vue} from "vue-property-decorator";
import {Form} from "element-ui";
import {Action, Getter} from "vuex-class";
import {RSFORM_ACTION, RSFormActions} from "@/types/RSFormStore";
import {FormProps} from "@/types/form/FormProps";

@Component
export default class FormOne extends Vue {
  @Getter("rsForm/form") readonly rsForm!: FormProps;
  @Action(RSFORM_ACTION.UPDATE_RSFORM)
  updateRSForm!: RSFormActions["UPDATE_RSFORM"];

  form: FormProps = {company: "", name: "", phone: null, email: "", jobTitle: ""};
  windowHeight = document.body.clientWidth || 0;
  rules = {
    company: [{required: true, message: "請輸入公司名稱", trigger: ["blur", "change"]}],
    name: [{required: true, message: "請輸入姓名", trigger: ["blur", "change"]}],
    phone: [{required: true, message: "請輸入電話", trigger: ["blur", "change"]}],
    email: [
      {required: true, message: "請輸入 E-mail", trigger: ["blur", "change"]},
      {type: "email", message: "請輸入正確的 E-mail", trigger: ["blur", "change"]},
    ],
    jobTitle: [{required: true, message: "請輸入職稱", trigger: ["blur", "change"]}],
  };

  beforeMount(): void {
    if (this.rsForm.email) {
      this.form = {...this.rsForm};
    }
  }

  mounted(): void {
    window.addEventListener("resize", this.onResize);
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.onResize);
  }

  goToFormTwo(): void {
    (this.$refs["form1"] as Form).validate((valid) => {
      if (valid) {
        this.updateRSForm(this.form);
        this.$router.push({name: "Form2"});
      }
    });
  }

  onResize(): void {
    this.windowHeight = document.body.clientWidth || 0;
  }

  get labelPosition(): string {
    return this.windowHeight < 768 ? "top" : "left";
  }
}
